export default "__VITE_ASSET__13015efb__"